import { Link } from "react-router-dom"
import { RoutePaths } from "../routes"
import { Accordion, AccordionSummary, AccordionDetails, Typography, Container, Box, Link as MuiLink } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { useFaq } from "../hooks/useFaq"; 
import { BlocksRenderer } from "@strapi/blocks-react-renderer";


const FaqPage = () => {
    const faqData = useFaq();
    console.log(faqData);
    return (
        <>
            <Typography variant="h1">Поддержка участников</Typography>

            {faqData.faq.map((item, index) => (
                <Accordion key={index}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography variant="h5">{item.question}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body4" sx={{lineHeight: '150%'}}>
                            <BlocksRenderer content={item.answer} />
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </>
    )
}

export default FaqPage
